export default __webpack_public_path__ + "static/media/3-cheese.72a9d664.png";